export enum PerformanceModelTypeEnum {
    Unknown = "Unknown",
    L0 = "L0",
    L1 = "L1"
}